import React from "react";
import PropTypes from "prop-types";

export const FormField = ({ label, required, select, children, ...props }) => {
    const commonClasses = `w-full xl:px-2 2xl:px-3 3xl:px-4 xl:py-1.5 2xl:py-2 3xl:py-2.5 xl:text-xs 2xl:text-sm 3xl:text-base
        xl:border xl:rounded-md 2xl:border-2 2xl:rounded-lg 3xl:border-2 3xl:rounded-lg
        border-gray-200 focus:outline-none xl:focus:ring-1 2xl:focus:ring-2 3xl:focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors
        ${props.disabled ? "bg-gray-100 text-gray-500" : ""}`;

    return (
        <div className="w-full">
            <label className="block xl:text-xs 2xl:text-sm 3xl:text-base font-medium text-gray-700 mb-1">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            {select ? (
                <select {...props} className={commonClasses}>
                    {children}
                </select>
            ) : (
                <input {...props} className={commonClasses} />
            )}
            {props.error && (
                <span className="text-red-500 xl:text-xs 2xl:text-sm 3xl:text-base mt-1">
                    {props.helperText}
                </span>
            )}
        </div>
    );
};

FormField.propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    select: PropTypes.bool,
    children: PropTypes.node,
    error: PropTypes.bool,
    helperText: PropTypes.string,
};

FormField.defaultProps = {
    required: false,
    select: false,
    error: false,
    helperText: "",
};
